/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createContainer,
	createStore,
	createActionsHook,
	type Action,
	type BoundActions,
	type HookActionsFunction,
	type OverrideContainerComponent,
	type Store,
} from '@atlassian/react-sweet-state';
import { loadEntityLimits } from './loadEntityLimits.tsx';
import { EMPTY_STATE } from './emptyState.constants.tsx';
import type { State, Props } from './State.types.tsx';

export type Actions = {
	readonly loadEntityLimits: () => Action<State, Props>;
};

const actions: Actions = {
	loadEntityLimits,
};

export const EntityLimitsStore: Store<State, Actions, unknown> = createStore<State, Actions>({
	initialState: EMPTY_STATE,
	actions,
	name: 'PolarisEntityLimitsStore',
});

export const useEntityLimitsActions: HookActionsFunction<BoundActions<State, Actions>> =
	createActionsHook(EntityLimitsStore);

export const EntityLimitsContainer: OverrideContainerComponent<Props> = createContainer<
	State,
	Actions,
	Props
>(EntityLimitsStore, {
	onInit:
		() =>
		({ dispatch }) =>
			dispatch(loadEntityLimits()),
});
